/**
 * GET URLs for the syndication games catalog (JSON body with `games: [...]`).
 * The admin UI fetches with `credentials: 'omit'` so no Bearer is sent to the partner origin.
 * CORS on the syndication host must allow the admin app origin.
 */
export function syndicationCatalogUrlCandidates(origin) {
  const o = origin == null ? '' : String(origin).trim().replace(/\/+$/, '');
  if (!o) {
    return [];
  }
  return [`${o}/syndication`];
}
